import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock';
import Auth from '../../../shared/Auth';
import CustomLineChart from '../../Custom/CustomLineChart';
import ChartLoader from '../../Loaders/ChartLoader';
import Axios from '../../../utils/axiosClient';

require('highcharts/modules/drag-panes')(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

class DCProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reinitialize: true,
      options: {},
    };
    this.getData = this.getData.bind(this);
    this.drawChart = this.drawChart.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.getData(nextProps.id, 1); // for month
    }
  }

  UNSAFE_componentWillMount() {
    this.getData(this.props.id, 1);
  }

  async getData(id, monthData) {
    this.setState({ reinitialize: true });
    const checkToken = await Auth();
    if (checkToken) {
      const url = `report/dcprofile/${id}/${monthData}`; // 0  for 6 month ,1 for 1 month
      console.log(url);
      Axios.get(url)
        .then((response) => {
          if (response.data.statusCode === 200) {
            this.drawChart(response.data.result, id, monthData);
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ reinitialize: false });
        });
    }
  }

  drawChart(result, id, monthData) {
    const self = this;
    const BatteryVDC = [];
    const BatteryADC = [];
    const units = result[0][0];
    const data = result[1];
    if (data.length > 0) {
      data.forEach(async (element) => {
        const tmstmp = Date.parse(element.ReportedDateTime.replace('_', ' '));
        BatteryVDC.push([tmstmp, parseFloat(element.Battery_VDC)]);
        BatteryADC.push([tmstmp, parseFloat(element.Battery_ADC)]);
      });
    }

    const chartObj = {
      yAxis: [
        {
          title: {
            text: `Current (${units.IUnit})`,
          },
        },
        {
          // Secondary yAxis
          title: {
            text: `Voltage (${units.VolUnit})`,
          },
          opposite: false,
        },
      ],
      selected: monthData === 1 ? 0 : 3,
      series: [
        {
          name: 'Battery ADC',
          color: 'red',
          data: BatteryADC,
        },
        {
          name: 'Battery VDC',
          color: 'green',
          yAxis: 1,
          data: BatteryVDC,
        },
      ],
      evnt: () => self.getData(id, 6),
    };

    this.setState({
      options: chartObj,
      reinitialize: false,
    });
  }

  render() {
    return (
      <div>
        {!this.state.reinitialize ? (
          <CustomLineChart options={this.state.options} />
        ) : (
          <ChartLoader height="150" width="600" />
        )}
      </div>
    );
  }
}

export default DCProfile;
